var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0914 8.20785C39.4653 8.6143 39.4389 9.24691 39.0325 9.62084L14.0625 32.5932C13.668 32.9562 13.0574 32.9435 12.6783 32.5644L1.7072 21.5932C1.31667 21.2027 1.31667 20.5696 1.7072 20.179L3.12141 18.7648C3.51194 18.3743 4.1451 18.3743 4.53563 18.7648L12.7937 27.0229C13.1728 27.402 13.7834 27.4147 14.1779 27.0518L36.3243 6.67712C36.7307 6.30319 37.3633 6.32955 37.7372 6.73599L39.0914 8.20785Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_Check.c7eb05da08a3cfcb0c9bbc2a052d545c.svg";
export { ForwardRef as ReactComponent };